import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import FilterRoundedIcon from '@mui/icons-material/FilterRounded';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined';
import { useSelector } from 'react-redux';

import { ID8_GEN_TYPES, ID8_TABS, PROJECT_VARIANTS } from '../../constants';
import { useProject } from '../../context/ProjectContext';
import IconTab from '../components/icon-tab/IconTab';

const useId8Tabs = () => {
  const { t } = useTranslation('id8');
  const { projectVariant } = useProject();

  const activeGeneratingStatuses = useSelector((state) => state.id8.activeGeneratingStatuses);

  return useMemo(() => {
    return [
      {
        label: <IconTab label={t('ideas')} icon={LightbulbOutlinedIcon} index={ID8_TABS.IDEAS} />,
        disabled: false,
      },
      {
        label: <IconTab label={t('images')} icon={FilterRoundedIcon} index={ID8_TABS.IMAGES} />,
        disabled: false,
        tooltip: false && t('areGenerating', { subject: t('images') }),
      },
      {
        label: <IconTab label={t('recreate')} icon={AddPhotoAlternateOutlinedIcon} index={ID8_TABS.RECREATE} />,
        disabled: false,
        tooltip: false && t('areGenerating', { subject: t('adImages') }),
      },
      {
        label: <IconTab label={t('liked')} icon={FavoriteBorderRoundedIcon} index={ID8_TABS.LIKED} />,
        disabled: true,
        tooltip: t('comingSoon'),
      },
      ...(projectVariant === PROJECT_VARIANTS.ADMIN
        ? [
            {
              label: <IconTab label={t('backup')} icon={HistoryRoundedIcon} index={ID8_TABS.BACKUP} />,
              disabled: activeGeneratingStatuses[ID8_GEN_TYPES.IDEAS],
              tooltip: activeGeneratingStatuses[ID8_GEN_TYPES.IDEAS] && t('areGenerating', { subject: t('messages') }),
            },
          ]
        : []),
    ];
  }, [t, activeGeneratingStatuses, projectVariant]);
};

export default useId8Tabs;
